import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationCancel,
  NavigationEnd,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import * as ownActions from '@redux/actions';
import {
  ApiJSONService,
  CommonsService,
  DomainBrandService,
  SeoService,
} from '@services/index';
import { LayoutInterface } from '@interfaces/index';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  data: LayoutInterface;
  loading: boolean;
  routerSubscription: any;
  private _subscription: Subscription = new Subscription();

  constructor(
    private _titleService: Title,
    private _router: Router,
    private _apiJSONService: ApiJSONService,
    private _commonsService: CommonsService,
    private _store: Store<AppState>,
    private _domainBrand: DomainBrandService,
    private _seo: SeoService
  ) {}

  /**
   * -------------------------------------------------------
   * @summary ngOnInit
   * @description  Inicializa funciones al cargar el
   * -------------------------------------------------------
   */
  ngOnInit() {
    this.applyBrandDocumentChrome();
    this._seo.setSiteName(this._domainBrand.documentTitle);
    this._subscription.add(
      this._router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe(() => this._seo.refreshCanonicalUrl())
    );
    this.getData();
    this.setLoading();
    this.setSubscriptions();
  }

  /**
   * -------------------------------------------------------
   * @summary setSubscriptions
   * @description Traer el valor del state del estado del translated de redux
   * -------------------------------------------------------
   */
  setSubscriptions() {
    this._subscription.add(
      this._store.select('layout').subscribe((state) => {
        this.loading = state.loading;
      })
    );
  }

  /**
   * -------------------------------------------------------
   * @summary getData
   * @description Retorna la data layout - menu y footer
   * -------------------------------------------------------
   */
  async getData() {
    await this._apiJSONService
      .getJSONLayout('../assets/data/layout.json')
      .subscribe(
        (resp) => {
          this.data = resp;
          this._store.dispatch(ownActions.setLoading({ loading: false }));
        },
        (error) => {
          console.error('Request failed with error');
          console.log(`error`, error);
        },
        () => {
        }
      );
  }

  /**
   * -------------------------------------------------------
   * @summary getData
   * @description  Activa e inactiva el Loading, Cambia el estado del loading cuando cargo la pagina y mada el route a un servicio para luego marcar como active la opcion del menu en base a su url
   * -------------------------------------------------------
   */
  setLoading() {
    // Muestra loading cuando carga la pagina
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._store.dispatch(ownActions.setLoading({ loading: true }));
      }
    });
    // Quita el loading cuando cargo la pagina y mada el route a un servicio para luego marcar como active la opcion del menu en base a su url
    this.routerSubscription = this._router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd || event instanceof NavigationCancel
        )
      )
      .subscribe((event) => {
        this._commonsService.getURlView(event, this._router.url);
        setTimeout(() => {
          this._store.dispatch(ownActions.setLoading({ loading: false }));
        }, 300);
      });
  }

  /**
   * -------------------------------------------------------
   * @summary toggleMenu
   * @description  Toggle de cambio del state para translate
   * @param {bollean} value valor del estado para abrir el menu
   * -------------------------------------------------------
   */
  toggleMenu(value: boolean) {
    this._store.dispatch(ownActions.setSubMenu({ submenu: value }));
  }

  private applyBrandDocumentChrome(): void {
    this._titleService.setTitle(this._domainBrand.documentTitle);
    if (typeof document === 'undefined') {
      return;
    }
    document.body.classList.toggle(
      'brand-sigma-industrial',
      this._domainBrand.brandId === 'sigma-industrial'
    );
    const href = this._domainBrand.faviconHref;
    const type = this._domainBrand.faviconType;
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = type;
    link.href = href;

    let shortcut = document.querySelector<HTMLLinkElement>(
      'link[rel="shortcut icon"]'
    );
    if (!shortcut) {
      shortcut = document.createElement('link');
      shortcut.rel = 'shortcut icon';
      document.head.appendChild(shortcut);
    }
    shortcut.href = href;
  }

  /**
   * -------------------------------------------------------
   * @summary ngOnDestroy
   * @description  Destruye conexiones abiertas
   * -------------------------------------------------------
   */
  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
    this._subscription.unsubscribe()
  }
}
